function CalendarTimeEventLocalVO(id, startDate, displayStartDate, endDate, displayEndDate, duration, displayDuration, color, opacity, zIndex, columnIndex, columnSpan, type, data) {

    this.id = id;
    this.startDate = startDate;
    this.displayStartDate = displayStartDate;
    this.endDate = endDate;
    this.displayEndDate = displayEndDate;
    this.duration = duration;
    this.displayDuration = displayDuration;

    this.columnIndex = columnIndex;
    this.columnSpan = columnSpan;

    this.color = color;
    this.opacity = opacity;
    this.zIndex = zIndex;

    this.type = type;
    this.data = data;

    var _typeContext = {
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}